(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lmdh-calcul-taille"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.lmdhSaisieTaille) return;
    window.lmdhSaisieTaille = true;
    let compteur = 0;
    const exemple = (champ) => (String(champ.placeholder || '').match(/\d+/) || ['210'])[0];
    const virgule = (n) => String(n).replace('.', ',');
    const ligne = (champ) => {
      let p = champ.lmdhSaisie;
      if (!p) {
        p = document.createElement('p');
        p.className = 'size-calc__saisie';
        p.id = 'size-calc-saisie-' + ++compteur;
        p.setAttribute('role', 'status');
        p.hidden = true;
        (champ.closest('.size-calc__row') || champ).insertAdjacentElement('afterend', p);
        champ.lmdhSaisie = p;
      }
      return p;
    };
    const effacer = (champ) => {
      if (!champ.lmdhSaisie) return;
      champ.lmdhSaisie.hidden = true;
      champ.lmdhSaisie.replaceChildren();
      // lmdh 12/10/2026 (lot AO5) : un champ marque hors de nos tailles par l assistant le reste
      if (!champ.dataset.lmdhHors) champ.removeAttribute('aria-invalid');
      champ.removeAttribute('aria-describedby');
    };
    const dire = (champ, texte, action) => {
      const p = ligne(champ);
      p.replaceChildren(document.createTextNode(texte));
      if (action) p.appendChild(action);
      p.hidden = false;
      champ.setAttribute('aria-invalid', 'true');
      champ.setAttribute('aria-describedby', p.id);
    };
    const examiner = (champ) => {
      const brut = String(champ.value).trim();
      const min = Number(champ.min) || 0;
      const x = Number(brut.replace(',', '.'));
      if (champ.validity && champ.validity.badInput) {
        dire(champ, 'Misura non riconosciuta: scrivila in centimetri, con le cifre, per esempio ' + exemple(champ) + '.');
      } else if (brut !== '' && x <= 0) {
        dire(champ, 'Una misura si indica in centimetri, maggiore di zero: per esempio ' + exemple(champ) + '.');
      } else if (brut !== '' && x > 0 && x < 10 && min >= 10) {
        const cm = Math.round(x * 100);
        const bouton = document.createElement('button');
        bouton.type = 'button';
        bouton.className = 'size-calc__saisie-action';
        bouton.textContent = 'Usa ' + cm + ' cm';
        bouton.addEventListener('click', () => {
          champ.value = String(cm);
          effacer(champ);
          champ.dispatchEvent(new Event('input', { bubbles: true }));
          champ.dispatchEvent(new Event('change', { bubbles: true }));
          champ.focus();
        });
        dire(champ, virgule(x) + ' m: in centimetri sono ' + cm + ' cm.', bouton);
      } else if (brut !== '' && x >= 10 && x < min) {
        // lmdh 12/10/2026 (lot AO, U34) : sous le minimum du champ (15 cm pour un canape), la mesure etait ignoree sans un mot
        dire(champ, virgule(x) + ' cm: controlla la misura, in centimetri. Per esempio, ' + exemple(champ) + '.');
      } else {
        effacer(champ);
      }
    };
    document.addEventListener('change', (e) => {
      if (e.target.matches && e.target.matches('.size-calc__input')) examiner(e.target);
    }, true);
    // lmdh 12/10/2026 (lot AO, U74, rapport 381) : l explication ne venait qu en quittant le champ ; elle vient aussi apres
    // une pause de la frappe (0,9 s), le champ toujours actif.
    const pauses = new WeakMap();
    document.addEventListener('input', (e) => {
      const champ = e.target;
      if (!champ.matches || !champ.matches('.size-calc__input')) return;
      clearTimeout(pauses.get(champ));
      pauses.set(champ, setTimeout(() => {
        if (String(champ.value).trim() !== '' || (champ.validity && champ.validity.badInput)) examiner(champ);
      }, 900));
    }, true);
    document.addEventListener('input', (e) => {
      const champ = e.target;
      if (!champ.matches || !champ.matches('.size-calc__input') || !champ.lmdhSaisie || champ.lmdhSaisie.hidden) return;
      const x = Number(String(champ.value).replace(',', '.'));
      if (!(champ.validity && champ.validity.badInput) && (champ.value === '' || x >= (Number(champ.min) || 0))) effacer(champ);
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
